import React from 'react';
import Collapsible from 'react-collapsible';

const AccordionPanel = ({ item }) => {
  return (
    <div>
      <Collapsible open={item.open} trigger={<div className="custom-trigger">{item.title}</div>}>
        <div className="custom-collapsible">
          <p>{item.content}</p>
        </div>
      </Collapsible>
      
    </div>
  );
};

export default AccordionPanel;